<template>
    <div class="mapWrap">
        <!-- <nut-navbar @on-click-back="back" :rightShow="false">查看定位</nut-navbar> -->
        <div class="mainmap">
            <tdt-map :center="state.center" :zoom="state.zoom">
                <tdt-marker :position="marker_car" :icon="icon_car"></tdt-marker>
                <tdt-infowindow :target="currentMarker.position" :closeButton="false" :minWidth="180" :offset="[4, -15]">
                    <div>
                        <div style="font-size: 14px;font-weight: bold;text-align: center;">车辆信息</div>
                        <strong>{{currentMarker.updatetime}}</strong>
                        <div>imei:{{ currentMarker.imei }},时速{{currentMarker.speed}}km/h</div>
                    </div>
                </tdt-infowindow>
            </tdt-map>
        </div>
        <van-cell is-link @click="showPopup"><van-icon size="30" name="arrow-up" /></van-cell>
        <van-popup position="bottom" closeable close-icon-position="top-right" class="discussIcon" ref="discussIcon"
            v-model="show">
            <i class="el-icon-minus"></i>
            <div class="dis-item">{{ this.address }}</div>
            <div class="dis-pg" style="margin-top: 20px;">车辆当前定位·<span>{{ this.address }}</span></div>
            <div class="anniu-item">
                <!-- @click="getnowlocation()" -->
                <div id="mid" @click="loop_get_position()" class="anniu-item1" style="flex: 1; margin-right: 2%;">
                    <div class="anniu-text anniuNew">GPS+北斗</div>
                    <div class="anniu-logo anniuNew">
                        <img src="../assets/images/takeoff.png">
                        <div>定位类型</div>
                    </div>
                </div>
                <div @click="getLocation()" class="anniu-item1" style="flex: 2;">
                    <div class="anniu-text anniuNew">{{ this.imei }}</div>
                    <div class="anniu-logo anniuNew">
                        <img src="../assets/images/backup.png">
                        <div class="typeNew">设备唯一识别号</div>
                    </div>
                </div>
            </div>
            <div class="state-item">
                <div class="velocity">
                    <div class="velocity1 stateText">行驶速度</div>
                    <div class="velocity2 stateCtn">{{carDetail.speed}}km/h</div>
                </div>
                <div class="stateNew">
                    <div class="stateNew1 stateText">设备行驶状态</div>
                    <div class="stateNew2 stateCtn">行驶</div>
                </div>
                <div class="elevation">
                    <div class="elevation1 stateText">海拔高度</div>
                    <div class="elevation2 stateCtn">{{carDetail.height}}</div>
                </div>
                <div class="direction">
                    <div class="direction1 stateText">方向/描述</div>
                    <div class="direction2 stateCtn">{{carDetail.direction}}°/正北方</div>
                </div>
            </div>
            <div class="address">
                <img class="address_img" src="../assets/images/group.png" alt="">
                <div class="address-item">
                    <div class="address-item1">
                        <span>{{ this.province }}</span>
                        <span>{{ this.city }}</span>
                        <span>{{ this.district }}</span>
                        <span>{{ this.street }}</span>
                    </div>
                    <div class="longitudes">经度：{{carDetail.longtitude}}</div>
                    <div class="latitudes">纬度：{{ carDetail.latitude }}</div>
                </div>
            </div>
            <div class="simSignal" v-if="false">
                <div class="simSnl">移动设备SIM卡信号强度</div>
                <div class="simGps">当前信号：<img src="../assets/images/Signal.png" alt=""></div>
                <el-divider></el-divider>
                <div class="starTime">GPS卫星定位收星数：<span style="color:#3478F6;">50</span></div>
                <el-divider></el-divider>
                <div class="endTime">北斗定位收星数：<span style="color:#3478F6;">50</span></div>
            </div>
            <div class="itemNew">
                <div class="StartTime">定位时间：<span style="color:#3478F6;">{{ this.starttime1 }}</span></div>
                <el-divider></el-divider>
                <div class="EndTime">最后通讯时间：<span style="color:#3478F6;">{{ this.endtime1 }}</span></div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import carimg from "../assets/images/pc_icon_06.png"
import startimg from "../assets/images/pc_icon_02.png"
import endimg from "../assets/images/pc_icon_04.png"
import { resize } from "../assets/js/dom";
// import preventBack from 'vue-prevent-browser-back';
export default {
    // mixins: [preventBack],//阻止返回上一页
    name: 'dragDrop',
    data() {
        return {
            //返回到指定页面
            replaceUrl: "",
            //是否展示位置详情
            show: false,
            imei: "",
            enter_flag: "",
            map: null,
            lngs: "",//经度
            lats: "",//纬度
            province: '',//地区
            address: "",
            city: "",
            district: "",
            street: "",
            // url: "http://192.168.88.43:5689/",
            url: "http://www.bd-gps.com/bdgps/",
            radio2: "一天",
            starttime: "",
            starttime1: "",//定位时间
            endtime1: "",//最后的定位时间
            endtime: "",
            // showmianban: false,
            fromtype: "",
            trace_history: null,
            marker: {
                marker_location: null,
                marker_start: null,
                marker_end: null,
                marker_car: null
            },
            now_num: 0,
            interval: null,
            // show_timeshaixuan: true,
            stop: true,
            bofang_sudu: 40,
            state: {
                center: [],
                zoom: 12
            },
            marker_car: [],
            icon_car: {
                iconUrl: carimg,
                iconSize: [25, 40],
                iconAnchor: [10, 25]
            },
            currentMarker: {},
            carDetail:{}
}
    },
computed: {
    show_time() {
        if (this.trace_history) {
            return this.trace_history.points[this.now_num].create_time.substring(0, 18)
        } else {
            return "-"
        }
    },
    show_sudu() {
        if (this.trace_history) {
            return this.trace_history.points[this.now_num].speed
        } else {
            return "-"
        }
    },
    maxnum() {
        if (this.trace_history) {
            return this.trace_history.points.length - 1
        } else {
            return 100
        }
    }
},
methods: {
    showPopup() {
        this.show = true;
    },

    back() {
        this.$router.go(-1)
    },
    getnowtime() {
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth();//得到月份
        var date = now.getDate();//得到日期
        var day = now.getDay();//得到周几
        var hour = now.getHours();//得到小时
        var minu = now.getMinutes();//得到分钟
        var sec = now.getSeconds();//得到秒
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        if (hour < 10) hour = "0" + hour;
        if (minu < 10) minu = "0" + minu;
        if (sec < 10) sec = "0" + sec;
        var time = "";
        time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec
        return time
    },
    GetDateStr(AddDayCount) {
        var dd = new Date();
        dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
        var hour = dd.getHours() < 10 ? "0" + dd.getHours() : dd.getHours();
        var minu = dd.getMinutes() < 10 ? "0" + dd.getMinutes() : dd.getMinutes();
        var sec = dd.getSeconds() < 10 ? "0" + dd.getSeconds() : dd.getSeconds();
        return y + "-" + m + "-" + d + " " + hour + ":" + minu + ":" + sec;
    },

    drawmap() {
        this.state = {
            center: [116.404, 39.915],
            zoom: 14
        }
        this.getLocation()
    },
    loop_get_position(){
        return new Promise((resolve, reject)=>{
            console.log("获取当前坐标")
            var lo = new T.Geolocation();
            lo.getCurrentPosition(function (e) {
                console.log(e)
                if (this.getStatus() == 0){
                    let data = {
                        coords:{
                            longitude:e.lnglat.lng,
                            latitude:e.lnglat.lat,
                        }
                    }
                    resolve(data)
                }
                if(this.getStatus() == 1){
                    let data = {
                        coords:{
                            longitude:e.lnglat.lng,
                            latitude:e.lnglat.lat,
                        }
                    }
                    resolve(data)
                }
            });
        })
    },
    getnowlocation() {
        const _this = this
        const geolocation = new BMap.Geolocation()
        // this.confirmLoading = true
        geolocation.getCurrentPosition(function (r) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                let myGeo = new BMap.Geocoder()
                myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), function (result) {
                    // _this.confirmLoading = false
                    if (result) {
                        console.log(JSON.stringify(result))
                        _this.map.centerAndZoom(new BMap.Point(result.point.lng, result.point.lat), 14);
                        _this.latitude = result.point.lat
                        _this.longitude = result.point.lng
                        _this.address = result.address
                        _this.province = result.addressComponents.province
                        _this.city = result.addressComponents.city
                        _this.district = result.addressComponents.district
                        _this.street = result.addressComponents.street
                    }
                })
            }
        })
    },
    getLocation() {
        this.$axios.get(this.url + "api/GPS/GetImei_ssinfo", {
            params: {
                imei: this.imei,
                enter_flag: this.enter_flag,
            }
        })
            .then(res => {
                this.lngs = res.data.Data[0].longtitude
                this.lats = res.data.Data[0].latitude
                this.endtime1 = res.data.Data[0].lasttime
                // console.log(res.data.Data[0].longtitude + "," + res.data.Data[0].latitude)
                if (res.data.result == 'success') {
                    this.carDetail = res.data.Data[0]
                    this.state = {
                        center: [res.data.Data[0].longtitude, res.data.Data[0].latitude],
                        zoom: 14
                    }
                    this.marker_car = [res.data.Data[0].longtitude, res.data.Data[0].latitude]
                    var mylocation_pic = new BMap.Icon(carimg, new BMap.Size(26, 80), { imageOffset: new BMap.Size(0, 0) });
                    this.marker.marker_location = new BMap.Marker(new BMap.Point(res.data.Data[0].longtitude, res.data.Data[0].latitude), {
                        icon: mylocation_pic
                    });
                    var item = res.data.Data[0]
                    this.starttime1 = res.data.Data[0].updatetime
                    this.currentMarker = {
                        updatetime:item['updatetime'] ? item['updatetime'].replace('.000', '') : '',
                        imei:item['imei'],
                        speed:item['speed'],
                        position:[res.data.Data[0].longtitude, res.data.Data[0].latitude],
                    }
                }
            })
            .catch((error) => {
                // console.log(error)
            })
    },
},
watch: {

},
mounted() {
    if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        /*popstate触发时机：当前历史条目为pushState创建时，事件被触发*/
        window.addEventListener('popstate', this.goRouteBack, false);
    }
    // console.log(this.$route.params.imei)
    this.endtime = this.getnowtime()
    this.starttime = this.GetDateStr(-1)
    this.imei = this.$route.params.imei
    this.fromtype = this.$route.params.fromtype
    this.drawmap()
},
}
</script>

<style scoped>
.mapWrap {
    width: 100%;
    height: 100%;
    position: relative;
}

/* 上拉 */
.van-cell__value--alone {
    margin-left: 45%;
}

.el-icon-minus {
    font-size: 48px;
    position: absolute;
    left: 50%;
    top: 2%;
    /* margin-left: 50%; */
    transform: translate(-50%);
    color: #BFBFC1;
    line-height: 0%;
}

.mapWrap .discussIcon .dis-item {
    color: #000000;
    font-size: 30px;
    width: 66%;
    /* height: 10%; */
    margin-left: 15px;
    font-weight: bold;
    margin-top: 6%;
}

.mapWrap .discussIcon .dis-pg {
    margin: 3% 0px;
    margin-left: 4%;
}

.mapWrap .discussIcon .dis-pg span {
    color: #2C84E2;
}

.mapWrap .discussIcon .anniu-item {
    display: flex;
    margin: 0px 4%;
}

.anniuNew {
    color: #FFFFFF;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.anniu-text {
    display: flex;
    justify-content: center;
    align-items: center;
}

.mapWrap .discussIcon .anniu-item .anniu-item1 {
    border-radius: 8px;
    background-color: #3478F6;
}

.anniu-item1 .anniu-logo .typeNew {
    margin-bottom: 2%;
}

/* .mapWrap .discussIcon .anniu-item .anniu-item2 {
    flex: 3;
    line-height: 33px;
    margin-left: 15px;
    border-radius: 8px;
    background-color: #3478F6;
} */

.mapWrap .discussIcon .state-item {
    display: flex;
    justify-content: center;
    margin: 4% 4%;
}

.stateText {
    color: #999999;
    font-size: 15px;
    text-align: center;
}

.stateCtn {
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    padding: 5px 0px;
}

.discussIcon .state-item .velocity {
    flex: 1;
    border: 1px solid #B9B9B9;
    flex: 1;
    border-left: 0px;
    color: #EE7B30;
}

.discussIcon .state-item .stateNew {
    flex: 1;
    border: 1px solid #B9B9B9;
    border-right: 0px;
    border-left: 0px;
    color: #26AC02;
}

.discussIcon .state-item .elevation {
    flex: 1;
    border: 1px solid #B9B9B9;
    color: #2C84E2;
}

.discussIcon .state-item .direction {
    flex: 1;
    border: 1px solid #B9B9B9;
    border-right: 0px;
    border-left: 0px;
    color: #333333;
}

.discussIcon .address {
    display: flex;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    margin: 0px 4%;
    padding: 3%;
}

.discussIcon .address_img {
    height: 70px;
}

.address-item {
    margin-left: 3%;
}

.address-item .address-item1 {
    color: #3560F4;
    font-weight: bold;
}

.address-item .longitudes {
    margin: 3% 0px;
    color: #666666;
}

.address-item .latitudes {
    color: #666666;
}

.discussIcon .simSignal {
    background-color: #FFFFFF;
    box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    margin: 3% 4%;
    padding: 3%;
    color: #666666;
}

.discussIcon .simSignal .simGps {
    color: #3478F6;
    margin-top: 3%;
}

.simSignal .simGps img {
    width: 30px;
}

.el-divider--horizontal {
    margin: 15px 0px;
}

.discussIcon .itemNew {
    background-color: #FFFFFF;
    box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    margin: 3% 4%;
    padding: 3%;
    color: #666666;
}

@media (max-width:380px) {
    .mapWrap {
        font-size: 12px;
    }

    .mapWrap .discussIcon .dis-item {
        font-size: 20px;
    }

    .stateText {
        font-size: 12px !important;
    }

    .stateCtn {
        font-size: 14px !important;
    }

    .discussIcon .address_img {
        height: 60px;
    }

    .simSignal .simGps img {
        width: 20px;
    }

    .el-divider--horizontal {
        margin: 11px 0px;
    }
}

@media (max-width:340px) {
    .mapWrap {
        font-size: 12px;
    }

    .mapWrap .discussIcon .dis-item {
        font-size: 20px;
    }

    .stateText {
        font-size: 12px !important;
    }

    .stateCtn {
        font-size: 10px !important;
    }
}

.mapWrap .mainmap {
    width: 100%;
    height: calc(100% - 40px);
    height: -webkit-calc(100% - 40px);
    height: -moz-calc(100% - 40px);
}
</style>



// WEBPACK FOOTER //
// src/pages/maps.vue